import { render, staticRenderFns } from "./CreateItineraryModal.vue?vue&type=template&id=1b6dd9a7&scoped=true&"
import script from "./CreateItineraryModal.vue?vue&type=script&lang=js&"
export * from "./CreateItineraryModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateItineraryModal.vue?vue&type=style&index=0&id=1b6dd9a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6dd9a7",
  null
  
)

export default component.exports